import { useEffect, useId } from 'react';
import { create } from 'zustand';

interface OverlayStore {
  openIds: Set<string>;
  register: (id: string) => void;
  unregister: (id: string) => void;
}

export const useOverlayStore = create<OverlayStore>((set) => ({
  openIds: new Set<string>(),

  register: (id) => set((state) => ({ openIds: new Set(state.openIds).add(id) })),

  unregister: (id) =>
    set((state) => {
      const next = new Set(state.openIds);
      next.delete(id);
      return { openIds: next };
    }),
}));

export const selectAnyOverlayOpen = (state: OverlayStore): boolean => state.openIds.size > 0;

export const useRegisterOverlay = (isOpen: boolean): void => {
  const id = useId();
  const register = useOverlayStore((state) => state.register);
  const unregister = useOverlayStore((state) => state.unregister);

  useEffect(() => {
    if (isOpen) register(id);
    else unregister(id);

    return () => unregister(id);
  }, [isOpen, id, register, unregister]);
};

export const useAnyOverlayOpen = (): boolean => useOverlayStore(selectAnyOverlayOpen);
